import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

import { useAction } from 'app/hooks';
import { actions as modalsActions, modalTypes } from 'ducks/modals';
import { actions as clientsActions } from 'ducks/clients';
import { Button } from 'components';

const ActivateCard = memo((props) => {
  const { card, client } = props;
  const { id: cardId } = card;
  const { id: clientId } = client;
  const activateCard = useAction(clientsActions.activateCard);
  const showModal = useAction(modalsActions.showModal);

  const onClick = useCallback(() => {
    showModal(modalTypes.CONFIRMATION_MODAL, {
      onOk: () => activateCard(cardId, clientId),
    });
  }, [cardId, clientId, activateCard, showModal]);

  return (
    <Button variant="outlined" size="small" label="app:activate" onClick={onClick} marginLeft />
  );
});

ActivateCard.propTypes = {
  card: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
};

export default ActivateCard;
